/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useRef } from 'react'

import { useCityPage } from '@/context/CityPageContext'
import { getScrollbarWidth } from '@/utils/get-scrollbar-width'
import { addPositionFixedToBody, backToTopOnModalClose } from '@/utils/prevent-page-scroll-on-modal-open'

import { prerenderedModalInner, prerenderedModalOuter } from './styles.css'

type Props = {}

export const PrerenderedModal: React.FC<Props> = (props) => {
  const overlayRef = useRef(null)
  const { closeBreadcrumbModal, isBreadcrumbModalOpen } = useCityPage()

  useEffect(() => {
    if (isBreadcrumbModalOpen) {
      const scrollbarWidth = getScrollbarWidth()
      overlayRef.current.focus()
      addPositionFixedToBody(scrollbarWidth)
    } else {
      backToTopOnModalClose()
    }
  }, [isBreadcrumbModalOpen])

  return (
    <div
      ref={overlayRef}
      className={isBreadcrumbModalOpen ? prerenderedModalOuter.breadcrumbModalOpen : prerenderedModalOuter.default}
      data-testid="PrerenderedModalOverlay"
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if (e.target === overlayRef.current) {
          closeBreadcrumbModal()
        }
      }}
    >
      <div className={prerenderedModalInner}>{props.children}</div>
    </div>
  )
}
